import { useRouteLoaderData } from "@remix-run/react";

import { useLabels } from "~/hooks/useLabels";
import { SidePanelLayout } from "~/components/sidePanelLayout/SidePanelLayout";

import type { SessionRouteLoaderData } from "./route";

export interface SessionTeacherNotesProps {
  onRequestClose?: () => void;
  isDesktopLayout?: boolean;
}

export function SessionTeacherNotes({
  onRequestClose,
  isDesktopLayout,
}: SessionTeacherNotesProps) {
  const { t } = useLabels();

  const data = useRouteLoaderData(
    "routes/$class_.sessions.$session",
  ) as SessionRouteLoaderData;

  if (isDesktopLayout) {
    return (
      <SidePanelLayout
        title={t("session.tab.teacherNotes")}
        onRequestClose={onRequestClose}
      >
        <bp-teacher-notes arc-id={data.session.id}></bp-teacher-notes>
      </SidePanelLayout>
    );
  }

  return <bp-teacher-notes arc-id={data.session.id}></bp-teacher-notes>;
}
